import React, { forwardRef } from 'react';

import { BaseCell, type BaseCellProps, type SortDirection } from './base-cell';

export type THProps = Omit<BaseCellProps, 'as'>;

type InternalTHProps = THProps & {
	sortDirection?: SortDirection;
	ref?: React.RefObject<HTMLTableCellElement>;
};

/**
 * __Head cell__
 *
 * A head cell.
 *
 * @primitive
 */
export const TH = forwardRef<HTMLTableCellElement, InternalTHProps>((props, ref) => {
	return <BaseCell as="th" ref={ref} {...props} />;
});
